import { type AxiosInstance } from 'axios'

type Abatement = {
  company?: number
  scope: number
  project_name: string
  estimated_total_reduction: string
  start_year: number
  target_completion_year: number
  project_implemented_year?: number
  estimated_cost: string
  cost_per_mtco2e_reduced?: string
  mtco2e_per_dollar_spent?: string
}
interface EditAbatementData {
  company?: number | null
  scope?: number
  project_name: string
  estimated_total_reduction: string
  start_year: number
  target_completion_year: number
  project_implemented_year?: number | null
  estimated_cost: string
  cost_per_mtco2e_reduced?: string | null
  mtco2e_per_dollar_spent?: string | null
  created_by?: number | null
  last_updated_by?: number | null
}

export default (axios: AxiosInstance) => ({
  create(createData: Abatement) {
    return axios.post('/v1/abatements/', createData)
  },
  getAbatements() {
    return axios.get(`/v1/abatements/`)
  },
  deleteAbatements(projectId: number) {
    return axios.delete(`/v1/abatements/${projectId}/`)
  },
  editAbatements(id: number, data: EditAbatementData) {
    return axios.put(`/v1/abatements/${id}/`, data)
  },

})
